"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  NO_REQUEST: 0,
  REQUEST_CONSENT: 1,
  NO_COOKIES: 2,
  NOTIFY: 3
};
exports.default = _default;
module.exports = exports.default;